import React, { useState } from 'react';
import './Clases.css';

const Clases = () => {
  const [nombre, setNombre] = useState('');
  const [consulta, setConsulta] = useState('');

  const handleWhatsAppRedirect = () => {
    const mensaje =
`Hola! Quisiera consultar por el servicio de *Clases de Fotografía*.
Mi nombre es: ${nombre}

Consulta:
${consulta}

¿Podrían pasarme precios de *clases individuales o grupales*?`;
    const url = `https://wa.me/5491160035550?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const backgroundStyle = {
    backgroundImage: 'url("/images/fondo-clases.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  return (
    <div style={backgroundStyle} className="clases-bg">
      <div
        className="clases-overlay"
        style={{
          backgroundColor: 'rgba(237, 232, 227, 0.85)',
          backdropFilter: 'blur(1px)',
          minHeight: '100vh',
          paddingBottom: '2rem',
        }}
      >
        {/* Header */}
        <div className="clases-header">
          <h1 className="clases-title">Clases de Fotografía</h1>
          <p className="clases-description">
            Curso inicial con cámara réflex digital: vas a dominar exposición (velocidad, diafragma, ISO),
            enfoque, balance de blancos y composición. Son <strong>3 meses</strong>, 1 vez por semana,
            alternando teoría y práctica con <strong>salidas a locación</strong>. Desarrollamos la creatividad,
            la observación y el ojo crítico con feedback personalizado y ejercicios reales. <br />
            <em>Consultar por precio de clases individuales o grupales.</em>
          </p>
        </div>

        {/* Imagen “descentrada” que pisa mitad header / mitad fondo */}
        <div className="clases-imagen-descentrada">
          <img
            src="/images/clases-fotografia.jpg"
            alt="Clases de fotografía en acción"
          />
        </div>

        {/* Contenido principal */}
        <div className="clases-container">
          {/* ¿Cómo funciona? */}
          <div className="clases-pasos">
            <h2>¿Cómo funciona?</h2>
            <div className="clases-pasos-grid">
              <div className="clases-paso">
                <span className="clases-paso-num">1</span>
                <p>Te inscribís y coordinamos calendario</p>
              </div>
              <div className="clases-paso">
                <span className="clases-paso-num">2</span>
                <p>Clases teóricas con ejercicios guiados</p>
              </div>
              <div className="clases-paso">
                <span className="clases-paso-num">3</span>
                <p>Prácticas y salidas a distintas locaciones</p>
              </div>
              <div className="clases-paso">
                <span className="clases-paso-num">4</span>
                <p>Feedback, edición básica y proyecto final</p>
              </div>
            </div>
          </div>

          {/* CTA final */}
          <div className="clases-cta-final">
            <h2>¿Listo para sacar en modo manual?</h2>
            <p>Escribinos y armamos tu plan: individual o en grupo.</p>
            <div className="clases-form">
              <input
                type="text"
                placeholder="Tu nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
              <textarea
                placeholder="Contanos en qué querés enfocarte (nivel, cámara, dudas)"
                value={consulta}
                onChange={(e) => setConsulta(e.target.value)}
                rows={4}
              />
            </div>
            <button onClick={handleWhatsAppRedirect}>Consultar ahora</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clases;
